import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import WebhookManagement from './pages/webhook-management';
import AdminLogin from './pages/admin-login';
import APIDocumentationHub from './pages/api-documentation-hub';
import ProductCategoriesManagement from './pages/product-categories-management';
import ApiKeyManagement from './pages/api-key-management';
import ClientManagement from './pages/client-management';
import ProductManagement from './pages/product-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AdminLogin />} />
        {/* <Route path="/webhook-management" element={<WebhookManagement />} /> */}
        <Route path="/product-management" element={<ProductManagement />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/api-documentation-hub" element={<APIDocumentationHub />} />
        <Route path="/product-categories-management" element={<ProductCategoriesManagement />} />
        {/* <Route path="/api-key-management" element={<ApiKeyManagement />} /> */}
        <Route path="/client-management" element={<ClientManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
